// extracted by mini-css-extract-plugin
module.exports = {"item":"DashboardBottomBar_item__1axEx","round":"DashboardBottomBar_round__2qtgb"};